module.exports = __webpack_public_path__ + "img/pinterest.85b3930c.svg";